var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// ./~/.lodash@4.17.4@lodash/_getPrototype.js
// module id = 32
// module chunks = 0